.layoutBar {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(1rem);
  min-height: 40px;
  gap: 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.logoSection {
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  width: auto;
}

.pageInfo {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.pageName {
  color: #1c1c1c;
  font-family: "League Gothic", "Arial Black", Arial, sans-serif;
  font-size: 1.75rem;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pageTitleSection {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  flex: 1;
  min-width: 0;
}

/* Hide pageName when scrolled and showing title */
.pageInfo:has(.pageTitleSection) .pageName {
  display: none;
}

.pageTitle {
  color: #1c1c1c;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.pageSubtitle {
  color: #666;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.3;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.mobileToggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 4px;
  color: #1c1c1c;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobileToggle svg {
  width: 30px;
  height: 30px;
}

@media (max-width: 768px) {
  .layoutBar {
    gap: 0.5rem;
    padding-left: 0.5rem;
  }

  .mobileToggle {
    display: flex;
  }

  .pageName {
    font-size: 1.5rem;
  }

  .pageTitle {
    font-size: 1rem;
  }

  .pageSubtitle {
    font-size: 0.8rem;
  }
}

@media print {
  .layoutBar {
    border-bottom: none !important;
    position: relative !important;
  }
  .layoutBar .mobileToggle {
    display: none !important;
  }
  .pageTitleSection {
    display: none !important;
  }
  .pageName {
    display: block !important;
  }
}
